import React, { useState } from 'react';
import Modal from '../ProfileV2/shared/Modal';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import Icons from '@components/shared/icons';
import Fetch from '@components/util/Fetch';
import InfoCircleIcon from '@images/info-circle.png';

import './styles.scss';

const PledgeFirstTitleModal = () => {
  const [isOpen, setIsOpen] = useState(true);

  const logDisruptorViewed = () => {
    Fetch.post({ url: '/title_matches/log_first_title_pledge_disruptor_viewed' });
    logCrmEvent('disruptor_dismissed', { type: 'pledge_first_title' });
  };

  const dismiss = () => {
    logDisruptorViewed();
    setIsOpen(false);
  };

  const submit = () => {
    logDisruptorViewed();
    window.location = '/title_matches';
  };

  return (
    <Modal
      close={dismiss}
      id="pledge-first-title-modal"
      status={isOpen ? 'active' : 'hidden'}
    >
      <div className="pledge-first-title-modal edit-modal-inner">
        <button
          type="button"
          className="close-button"
          onClick={dismiss}
        >
          <Icons type="close" />
        </button>
        <img
          src={InfoCircleIcon}
          width={64}
          height={64}
          className="check-icon margin-bottom-16"
          alt="Information"
        />
        <p className="pledge-first-text large-slim-font margin-bottom-24">
          Don't let your next closing get delayed. Secure a seamless closing and pledge title today.
        </p>
        <div className="button-container">
          <button
            type="button"
            className="profile-edit-button submit"
            onClick={submit}
          >
            PLEDGE TITLE NOW
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PledgeFirstTitleModal;
